import { AttributeValueInput } from "../types";
import { MappingContext } from "../orchestrator";
import { valueMapperConfigSchema } from "../schemas";
import { memoizeMapperFactory } from "../utils/memoize";

/**
 * Internal implementation of valueMapper without memoization.
 */
function valueMapperImpl(config: unknown) {
  const parsedConfig = valueMapperConfigSchema.parse(config);

  return (response: string, _context: MappingContext): AttributeValueInput[] => {
    const mapping = parsedConfig[response];
    if (!mapping) {
      return [];
    }

    // The schema ensures the attributes are valid, so we just add isSkipped.
    return mapping.map((attr) => ({ ...attr, isSkipped: false }));
  };
}

/**
 * Creates a mapper for direct value-to-attribute mappings.
 * @param config - A map where keys are response values and values are arrays of attributes to set.
 * This function is memoized to avoid repeated config parsing.
 */
export const valueMapper = memoizeMapperFactory(valueMapperImpl); 